import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M7 15v2","key":"svg-1"}],["path",{"d":"M10 11v6","key":"svg-2"}],["path",{"d":"M13 13v4","key":"svg-3"}]]

const IconAlignBoxBottomLeft = createReactComponent('outline', 'align-box-bottom-left', 'AlignBoxBottomLeft', __iconNode);

export default IconAlignBoxBottomLeft;